import { httpRequest } from "../../http";
import { EntityType } from "@models/fieldMap.model";
export class CommandListEntityTypes {
  async run(vertical?: string): Promise<EntityType[]> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/entity-types/`;
    const url = vertical ? `${base}?vertical=${encodeURIComponent(vertical)}` : base;
    return httpRequest<EntityType[]>(url, { method: "GET" });
  }
}
